export default __webpack_public_path__ + "static/media/IMG_00006.aee47bb6.jpeg";